<!--suppress CssUnresolvedCustomProperty -->
<template>
  <v-container
      fluid
      class="pa-6 transparent"
      v-resize="onResize"
      :style="cssProps"
      style="max-width: 83%;"

  >

    <v-row>
      <v-col cols="12">

        <!-- HEADER -->
        <div class="mb-8">
          <h1 class="text-h4 font-weight-bold mb-2">
            Catálogo de Trámites
          </h1>
          <p class="text-subtitle-1 grey--text text--darken-1">
            Encuentra y gestiona todos tus trámites gubernamentales en un solo lugar
          </p>
        </div>

        <!-- SEARCH -->
        <v-row class="mb-8">
          <v-col :cols="isMobile ? 9 : 11" class="pt-0 pb-0">
            <v-text-field
                solo
                rounded
                prepend-inner-icon="mdi-magnify"
                placeholder="Buscar trámite por nombre..."
                v-model="search"
                @keyup.enter="getProcessesByCategory"
            />
          </v-col>

          <v-col :cols="isMobile ? 3 : 1" class="pt-0 pb-0">
            <v-btn
                class="main_color white--text"
                large
                rounded
                block
                @click="getProcessesByCategory"
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <!-- CATEGORIES -->
        <v-card flat class="py-2 px-4 transparent">

          <v-row v-if="processesStore.categories">
            <v-col>
              <v-chip
                  v-for="category in processesStore.categories"
                  :key="category.id"
                  large
                  class="ma-1 font-weight-bold"
                  :class="currentCategoryId === category.id
                  ? 'primary white--text'
                  : 'white primary--text'"
                  @click="getProcessesByCategory(category)"
              >
                <v-icon
                    left
                    :class="currentCategoryId === category.id
                    ? 'white--text'
                    : 'primary--text'"
                >
                  mdi-chart-donut
                </v-icon>

                {{ textCapitalize(category.nombre) }}
              </v-chip>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <!-- PROCESS GRID -->
          <v-row v-if="processesStore.categories" align="stretch">

            <v-col
                cols="12"
                sm="6"
                md="4"
                lg="3"
                class="d-flex"
                v-for="process in processesStore.processes"
                :key="process.id"
            >
              <v-card
                  class="process-card d-flex flex-column"
                  elevation="0"
              >

                <!-- HEADER -->
                <div class="card-header custom-header">

                  <div class="icon-box">
                    <v-icon size="30" color="primary">
                      mdi-file-document-outline
                    </v-icon>
                  </div>

                  <v-chip
                      small
                      class="category-chip"
                      color="white"
                      text-color="primary"
                  >
                    <span class="category-chip-text">
                      {{ selectedCategory
                        ? textCapitalize(selectedCategory.nombre)
                        : 'Identidad y Copias Certificadas'
                      }}
                    </span>
                  </v-chip>

                </div>

                <!-- BODY -->
                <v-card-text class="text-center py-8 flex-grow-1 d-flex align-center justify-center">
                  <h3 class="process-title">
                    {{ textCapitalize(process.nombre) }}
                  </h3>
                </v-card-text>

                <!-- FOOTER -->
                <div class="text-center pb-6">
                  <v-btn
                      large
                      rounded
                      color="primary"
                      dark
                      class="px-10"
                      @click="goTo(process)"
                  >
                    Ver detalles
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </div>

              </v-card>
            </v-col>

          </v-row>

        </v-card>

      </v-col>
    </v-row>

  </v-container>
</template>
<script>
import {mapState, mapActions} from 'vuex';
import {processListRequest} from "../api/models/";

export default {
    name: "Processes",
    components: {
    },
    computed: {
        ...mapState({accountStore: state => state.account, processesStore: state => state.processes}),

        cssProps() {
            return {
                '--primary-color': this.$vuetify.theme.themes.light.primary,
                '--main-color': this.$vuetify.theme.themes.light.main_color,
            }
        }
    },
    data() {
        return {
            currentCategoryId: 1,
            showIdentidad: true,
            selectedCategory: null,
            isMobile: false,
            search:'',
        }
    },

    created() {
        this.$gtag.event('nuevo_tramite', { method: 'Google' }) // Google Analytics
    },

    mounted() {
        //Call to VueX module action
        this.getCategories()

        //Call to local method
        this.getProcessesByCategory(null)
    },

    methods: {
        ...mapActions('processes', ['getProcesses', 'getCategories']),

        goTo(process){
            this.$router.push({ name: 'process_requirement', params: { processId: process.id, processName: process.nombre}})
        },

        textCapitalize(val){
            var str = val.split('')
                        .map((letter, index) =>
                        index ? letter.toLowerCase() : letter.toUpperCase(),
                        )
                        .join('')
            // var txt = str.charAt(0).toUpperCase() + str.slice(1);

            return str
        },

        onHoverProcess(event, n){
            var s = document.getElementById('cardproccess'+n)
            var i = document.getElementById('cardproccess_i'+n)
            s.classList.add('main_color')
            s.classList.add('white--text')
            i.classList.remove('main_color--text')
            i.classList.add('white--text')
            // event.target.className += ' main_color'
        },

        outHoverProcess(event, n){
            var s = document.getElementById('cardproccess'+n)
            var i = document.getElementById('cardproccess_i'+n)
            s.classList.remove('main_color')
            s.classList.remove('white--text')
            i.classList.remove('white--text')
            i.classList.add('main_color--text')
            // event.target.className.replace(' main_color', '') 
        },

        getProcessesByCategory(category){
            if (category == null || category.id !== this.currentCategoryId){
                this.selectedCategory = category
                this.currentCategoryId = category ? category.id : 1

                let request = processListRequest()
                request.category_id = this.currentCategoryId
                request.type_of_person = this.accountStore.user.tipo_persona
                request.query = this.search

                this.getProcesses(request)
                this.search = '';
            }
        },

        loadSVGIcon(iconName){
            import('./../components/icons/'+iconName.slice(0, -4));

            return iconName.slice(0, -4)
        },

        /** FOR MOBILE **/
        getSelectedCategoryIcon(){
            return this.loadSVGIcon(
                this.selectedCategory ? this.selectedCategory.icono: this.processesStore.categories[0].icono
            )
        },

        getSelectedCategoryLabel(){
            return this.selectedCategory ? this.selectedCategory.nombre: this.processesStore.categories[0].nombre
        },
        onResize() {
            if (window.innerWidth < 769) this.isMobile = true;
            else this.isMobile = false;
        },
        /** ENDS FOR MOBILE **/
    },

}
</script>

<style scoped>
    .category-menu .title{max-width: 170px}
    .category-menu .title{max-width: 170px}
    .category-menu.selected svg{
        fill: var(--main-color) !important;
        opacity: 1;    
    }
    .category-menu svg {
        fill: #b3b3b3;
    }
    .tramite_ico svg{
        fill: #555;
    }
    .tramite_ico .v-card__text{
        color: #555 !important;
    }

    .process-card {
      border-radius: 30px;
      overflow: hidden;
      border: 2px solid #e0e0e0;
    }

    .card-header {
      height: 140px;
      position: relative;
      padding: 20px;
      border-top-left-radius: 30px;
      border-top-right-radius: 30px;
    }
    .process-card {
      width: 100%;
      height: 100%;
    }

    /* Caja blanca del icono */
    .icon-box {
      margin-top: -3rem;
      margin-left: -4rem;
      background: #f3f3f3;
      width: 55px;
      height: 55px;

      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }


    .custom-header {
      background-color: var(--primary-color);
      position: relative;
      overflow: hidden;

      display: flex;
      align-items: center;
      gap: 12px;

      height: 140px;
      padding: 20px 20px 20px 90px; /* espacio izquierdo */
    }
    .custom-header::before {
      content: "";
      position: absolute;
      left: -10px;
      top: 50%;
      transform: translateY(-50%);
      width: 160px;
      height: 160px;

      background-image: url('../assets/icons/escudo.svg');
      background-repeat: no-repeat;
      background-size: contain;

      color: var(--main-color); /* <-- el color que quieres */
      opacity: 0.08;
      pointer-events: none;
    }

    /* Chip categoría */
    .category-chip {
      position: absolute;
      top: 25px;
      right: 25px;
      border-radius: 50px;
      font-weight: bold;
      padding-left: 20px;
      padding-right: 20px;
    }

    .process-title {
      font-size: 1.2rem;
      font-weight: 700;
      color: #000;
    }

    .category-chip {
      position: absolute;
      top: 25px;
      right: 25px;
      max-width: 49%; /* evita que invada el icono */
      border-radius: 50px;
      font-weight: bold;
      padding-left: 16px;
      padding-right: 16px;
    }
    .category-chip-text {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }


</style>